import React, {useEffect, useState } from "react";
import AsyncSelect from "react-select/async";
import { components} from "react-select"
import { useController, Controller } from "react-hook-form";
import _ from "lodash";
const Input = (props) => <components.Input {...props} isHidden={false} />;


export const AsyncSelectField = React.forwardRef((props, ref) => {
  const [focusState, setFocusState] = useState(false);
  const [inputValue, setInputValue] = useState();
  const { editableInput, isHighLight = false, title, style, type, errors, defaultValue, controlStyle = {}, isDisabled=false, menuPlacement = 'auto', showMenuOnTop=false, ...others } = props;
  const { field } = useController(props);
  const [debounce, setDebounce] = useState({});

  let err = _.get(errors, props.name);
  useEffect(() => {
    const { cb, delay } = debounce;
    if (cb) {
      const timeout = setTimeout(cb, delay);
      return () => clearTimeout(timeout);
    }
  }, [debounce]);

  const getOptionLabel = (e) => {
    if (props.getOptionLabel) {
      return props.getOptionLabel(e);
    } else {
      return Array.isArray(props.showLabel) ? props.showLabel.map(key => e[key]).join(" - ") : e[props.showLabel || "label"];
    }
  };

  const normalizeSearchText = (value) => `${value || ""}`.toLowerCase().trim();

  const sortOptionsByInput = (options, searchValue) => {
    const query = normalizeSearchText(searchValue);
    if (!query || !Array.isArray(options)) {
      return options;
    }

    return [...options].sort((firstOption, secondOption) => {
      const firstLabel = normalizeSearchText(getOptionLabel(firstOption));
      const secondLabel = normalizeSearchText(getOptionLabel(secondOption));
      const getRank = (label) => {
        if (label === query) return 0;
        if (label.startsWith(query)) return 1;
        if (label.includes(query)) return 2;
        return 3;
      };
      const rankDiff = getRank(firstLabel) - getRank(secondLabel);
      if (rankDiff !== 0) {
        return rankDiff;
      }
      return firstLabel.indexOf(query) - secondLabel.indexOf(query) || firstLabel.localeCompare(secondLabel);
    });
  };

  const promiseOptions = (inputValue, callback) =>
    new Promise((resolve) => {
      setDebounce({
        cb: async () => {
          const options = await props.search(inputValue);
          resolve(sortOptionsByInput(options, inputValue));
        },
        delay: 500, // ms
      });

    });
  const handleInputChange = (e) => {
    setInputValue(e);
  };
  const customStyles = {
    control: (base, state) => ({
      ...base,
      height: !props?.isMulti ? 35 : "100%",
      minHeight: props.minHeight ? props.minHeight : 35,
      maxHeight: "100%",
      boxShadow: "none",
      background: isHighLight ? "#feffd7" : "",

      border: props.rules && err && "1px solid #dc2626",
      ...controlStyle
    }),

    menu: (provided, state) => ({
      ...provided,
      zIndex: 50,
    }),
  };

  return (
    <>
      <div className={`relative w-full  ${isDisabled && " cursor-not-allowed "} `}>
        <label
          htmlFor="name"
          className={`z-10 pointer-events-none absolute bg-white left-2 mt-1 inline-block px-2  ${isDisabled && "  bg-gray-100 cursor-not-allowed "}  ${props.rules && err ? "text-red-600" : "text-gray-600"
            } ${focusState || field?.value
              ? "-top-2 duration-300 text-xs rounded-lg"
              : "custom-top duration-300 text-base font-normal"
            }
            ${isHighLight && " bg-highLight  "}
            `}
        >
          {title}{" "}
          {props?.rules?.required?.value === true && (
            <span className="text-red-500 mt-10">*</span>
          )}
        </label>
        <Controller
          name={props?.name}
          rules={props?.rules}
          control={props?.control}
          defaultValue={defaultValue}
          render={({ field }) => (
            <AsyncSelect
              {...field}
              {...others}
              inputValue={editableInput?inputValue:undefined}
              menuIsOpen={props.menuIsOpen || undefined}
              ref={(e)=>{
                field?.ref(e);
                if(ref) {
                  ref.current = e;
                }
              }}
              components={ props?.CustomOption ? {Input, Option: props?.CustomOption}: editableInput ? {Input}:null}
              menuPortalTarget={ showMenuOnTop && document.body} 
              cacheOptions={props?.optionData?.length > 0}
              style={{
                width: "100vw",
              }}

              noOptionsMessage={() => null}
              isMulti={props?.isMulti}
              styles={customStyles}
              loadOptions={promiseOptions}
              openMenuOnFocus={props?.optionData?.length > 0}
              placeholder=""
              menuPlacement={menuPlacement}
              classNamePrefix="select"
              className="placeholder:text-black 
              basic-multi-select h-full
                            placeholder:font-normal 
                            placeholder:text-base ui-control-input
                             focus:border-teal-c-900 text-start
                            "
              isClearable
              onFocus={() => {setFocusState(true); 
                setInputValue(field?.value ? field?.value[props.showLabel || "label" ]:"") 
               if (props.onFocus) {
                props.onFocus(e);
              }}}
              onBlur={() => {
                if (props?.onBlur) {
                  props?.onBlur();
                }
                field.onBlur;
                setFocusState(false);
              }}
              onInputChange={handleInputChange}
              getOptionLabel={getOptionLabel}
              getOptionValue={(option) => option[props.showLabel || "label"]} // changes here!!!
              isDisabled={isDisabled ?isDisabled :false}
              defaultOptions={props.optionData ? props.optionData : ""}
              isOptionDisabled={(option) => option?.code_system && option?.code_system == 'icd9'}
              onChange={(e) => {
                field.onChange(e);
                if (props.onChange) {
                  props.onChange(e);
                }
                setInputValue(e ? e[props.showLabel || "label" ] :"")
              }}
            />
          )}
        />
      </div>
      
      {props.rules && err && props.rules && err?.message ?
        <p className=" text-xs text-red-600 h-3 text-left" id="email-error">
          {err.message}
        </p>
      : null}
    </>
  );
});
